import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiQueryParams, ApiResponse } from "types/api";

import { transformManifestResponse } from "./transformers";
import { Manifest, ManifestRaw } from "./types";

export const useManifestHistory = (
  id: string,
  queryParams?: ApiQueryParams
) => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<Manifest[]>>({
    queryKey: ["manifestHistory", { id, queryParams }],
    queryFn: async () => {
      const response: ApiResponse<ManifestRaw[]> = await dispatch(
        apiThatThrows.getAppManifestChangelog.action({
          params: { id },
          queryParams,
        })
      );
      return {
        meta: response.meta,
        results: response.results
          .map((manifestRawResponse) =>
            transformManifestResponse({
              results: manifestRawResponse,
            })
          )
          .map((manifestResponse) => manifestResponse.results),
      };
    },
    enabled: Boolean(id),
  });
};
